export enum PageSizeKeyEnum {
  PAGINATION_SIZE = 'PAGINATION_SIZE',
  CONTACTS = 'CONTACTS',
  CONTACT_LIST_CONTACTS = 'CONTACT_LIST_CONTACTS',
  LOTUS_CONTACTS = 'LOTUS_CONTACTS',
  MEETINGS = 'MEETINGS',
  COMPANIES = 'COMPANIES',
  GROUPS = 'GROUPS',
  OFFERS = 'OFFERS',
  PERSONS = 'PERSONS',
  BD_PLANNING = 'BD_PLANNING'
}
